import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from "@angular/core";

@Component({
    selector: 'app-filter',
    templateUrl: './filter.component.html',
    styleUrls: ['./filter.component.scss']
})
export class FilterComponent implements OnChanges {
    @Input() model: any; // model to perform search from
    @Input() searchString: string; // required. search string 
    @Input() headerText: string;
    @Input() shouldClear = true;
    @Output() results = new EventEmitter();
    @Output() searchClicked = new EventEmitter();
    @Output() clearClicked = new EventEmitter();
    header = {
        icon: 'fa fa-filter',
        text: ''
    }
    constructor() { }
    ngOnChanges(changes: SimpleChanges) {
        if ('headerText' in changes) {
            let headerText = changes['headerText'].currentValue;
            if (headerText) {
                this.header.text = headerText;
            }
        }
    }
    search() {
        if (this.model)
            this.model.search(this.searchString).subscribe(results => {
                this.results.emit(results);
            });
        else {
            this.searchClicked.emit();
        }
    }
    clear() {
        this.clearClicked.emit();
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/shared/filter/filter.component.ts